export const WalletReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_WALLET_REFUND_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        refunds: null,
      };
    case "GET_WALLET_REFUND_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        refunds: action.payload,
      };
    case "GET_WALLET_REFUND_LIST_FAILED":
      return {
        ...state,
        loading: false,
        refunds: action.payload,
      };
    case "GET_WALLET_REFUND_REQUEST":
      return {
        ...state,
        loading: true,
        individualRefund: null,
      };
    case "GET_WALLET_REFUND_SUCCESS":
      return {
        ...state,
        loading: false,
        individualRefund: action.payload,
      };
    case "GET_WALLET_REFUND_FAILED":
      return {
        ...state,
        loading: false,
        individualRefund: action.payload,
      };
    default:
      return state;
  }
};
